var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.appFooterLogo)?_c('v-footer',{staticClass:"transparent pa-0",attrs:{"absolute":""}},[_c('v-col',{staticClass:"text-center pa-0",attrs:{"cols":"12"}},[_c('img',{attrs:{"src":this.appFooterLogo}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }